module.exports = __webpack_public_path__ + "img/pdf.b5a8177.png";